/**
 * Opens the lightbox modal with the image that is specified in the data-modal-open attribute.
 * @param {*} modalId 
 * 
 * @example
   <img src={item.url} alt={item.alt} data-modal-id="product-image-modal" data-modal-open={item.url} />
 * 
 * and somewhere this:  
  <div class="nioomi-modal-wrapper overlay" id="product-image-modal">
    <div class="overlay__clickTarget nioomi-modal__overlay"></div>
    <div class="dialog nioomi-modal nioomi-modal--lightbox">
      <div class="nioomi-modal__content"></div>
    </div>
  </div>
 */
export default function initLightbox(modalId) {
  const modalWrapper = document.getElementById(modalId);
  const modal = modalWrapper.querySelector(".nioomi-modal");
  const modalContent = modalWrapper.querySelector(".nioomi-modal__content");
  const modalCloser = modalWrapper.querySelector(".nioomi-modal__closer");
  const modalOverlay = modalWrapper.querySelector(".nioomi-modal__overlay");

  document
    .querySelectorAll(`[data-modal-id="${modalId}"]`)
    .forEach((trigger) => {
      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        const imageSrc = event.target.getAttribute("data-modal-open");
        modalContent.innerHTML = `<img src="${imageSrc}" />`;
        modal.classList.add("nioomi-modal-enter");
        modalWrapper.classList.add("overlay--open");
        setTimeout(() => {
          modal.classList.add("nioomi-modal-enter-done");
        }, 250);
      });
    });
  function close(event) {
    event.preventDefault();
    modal.classList.add("nioomi-modal-exit");
    setTimeout(() => {
      modalWrapper.classList.remove("overlay--open");
      modal.classList.remove("nioomi-modal-enter");
      modal.classList.remove("nioomi-modal-enter-done");
      modal.classList.remove("nioomi-modal-exit");
    }, 240);
  }
  modalCloser && modalCloser.addEventListener("click", close);
  modalOverlay && modalOverlay.addEventListener("click", close);
}
